var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "tags-wrapper",
      class: {
        active: _vm.isFocused || _vm.vValue,
        activeoverlay: _vm.focusOverlay && !_vm.overlayInactive,
        "w-hldr": _vm.tagsCount > 0,
      },
      on: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.onClick.apply(null, arguments)
        },
      },
    },
    [
      _c("span", { staticClass: "placeholder" }, [
        _vm._v(_vm._s(_vm.placeholder)),
      ]),
      _vm._v(" "),
      _c("tags-input", {
        ref: "input",
        attrs: {
          "element-id": "tags",
          "existing-tags": _vm.Global.assetsTags,
          typeahead: true,
          "typeahead-activation-threshold": 0,
          "typeahead-hide-discard": true,
          "only-existing-tags": false,
          limit: 3,
          "hide-input-on-limit": true,
          "typeahead-show-on-focus": true,
          "typeahead-always-show": _vm.forcedShow,
        },
        on: {
          "tag-added": _vm.onTagAdded,
          "tag-removed": _vm.onTagRemoved,
          keydown: _vm.onKeyDown,
          keyup: _vm.onKeyUp,
          focus: _vm.onFocus,
          blur: _vm.onBlur,
          change: _vm.onChange,
          input: _vm.onInput,
        },
        model: {
          value: _vm.selectedTags,
          callback: function ($$v) {
            _vm.selectedTags = $$v
          },
          expression: "selectedTags",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }